import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

interface PhoneInputFieldProps {
  isLoading: boolean;
  onChange: (v: string | undefined) => void;
  onSubmit: () => void;
  value: string | undefined;
}

function PhoneInputField({
  isLoading,
  onChange,
  onSubmit,
  value,
}: PhoneInputFieldProps) {
  return (
    <PhoneInput
      id="mfa-phone-input"
      className="w-full rounded-md border border-read-only-bg bg-white px-3 py-2 [&_.PhoneInputInput]:border-none [&_.PhoneInputInput]:bg-transparent [&_.PhoneInputInput]:p-0 [&_.PhoneInputInput]:text-base [&_.PhoneInputInput]:leading-normal [&_.PhoneInputInput]:outline-none"
      defaultCountry="AU"
      international
      value={value}
      onChange={onChange}
      onKeyDown={(e: React.KeyboardEvent) => {
        if (
          e.key === 'Enter' &&
          value &&
          isValidPhoneNumber(value) &&
          !isLoading
        ) {
          onSubmit();
        }
      }}
    />
  );
}

export { isValidPhoneNumber };
export default PhoneInputField;
